export const data = [
  {
    id: 1,
    title: "POPULAR SALE",
    description: "DON'T COMPROPISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS",
    image:
      "https://static.vecteezy.com/system/resources/previews/030/768/081/original/handsome-business-man-isolated-on-white-png.png",
    bgColor: "f5f8f8",
  },
  {
    id: 2,
    title: "SUMMER SALE",
    description: "DON'T COMPROPISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS",
    image:
      "https://www.pngall.com/wp-content/uploads/5/Model-Man-PNG-Picture.png",
    bgColor: "eeedee",
  },
  {
    id: 1,
    title: "WINTER SALE",
    description: "DON'T COMPROPISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS",
    image:
      "https://static.vecteezy.com/system/resources/previews/036/421/064/large_2x/ai-generated-young-stylish-man-posing-isolated-on-white-background-free-png.png",
    bgColor: "f5f8ff",
  },
];